import M$plugin$SearchSIPOB from 'C:/proyectos/searchsipob/searchsipob/src/facade/js/searchsipob';
import M$control$SearchSIPOBControl from 'C:/proyectos/searchsipob/searchsipob/src/facade/js/searchsipobcontrol';
import M$impl$control$SearchSIPOBControl from 'C:/proyectos/searchsipob/searchsipob/src/impl/ol/js/searchsipobcontrol';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
if (!window.M.impl) window.M.impl = {};
if (!window.M.impl.control) window.M.impl.control = {};
window.M.plugin.SearchSIPOB = M$plugin$SearchSIPOB;
window.M.control.SearchSIPOBControl = M$control$SearchSIPOBControl;
window.M.impl.control.SearchSIPOBControl = M$impl$control$SearchSIPOBControl;
